// counter.ts
import * as user from '../actions/user.actions';
import { Filter } from '../models/filter.model';

export interface State {
  _id?: string;
  isFetching?: boolean;
  createdAt?: string;
  company?: string;
  email?: string;
  favourites?: any;
  name?: string;
  password?: string;
  updatedAt?: any;
  disabled?: boolean;
  flexes?: any;
  recents?: any[];
  filters?: Filter[];
  activeFilter?: any;
  loggedIn: boolean;
  error: boolean;
  role?: string;
}

export const initialState: any = {
  isFetching: false,
  filters: [],
  flexes: {},
  activeFilter: null,
  loggedIn: false,
  error: false
};

export function reducer(state: State = initialState, action: user.Actions): State {
  switch (action.type) {

    case user.LOGIN:
      return { ...state, ...{ loggedIn: false, error: false } };

    case user.LOGOUT_SUCCESS:
      return { ...initialState };

    case user.LOGIN_SUCCESS:
      return { ...action.payload, ...{ loggedIn: true, error: false } };

    case user.LOGIN_FAILURE:
      return { ...action.payload, ...{ loggedIn: false, error: false } };

    case user.SAVE_FLEX:
      return state;

    case user.TOGGLE_FLEX:
      state.flexes = state.flexes ? state.flexes : {};
      const flexSettings = state.flexes[action.payload.ticker] || {};
      state.flexes[action.payload.ticker] = Object.assign(flexSettings, { useFlex: action.payload.useFlex });
      return Object.assign({}, state);

    case user.SAVE_FLEX_SUCCESS:
      return Object.assign({}, state, action.payload, { error: false });

    case user.CREATE_FILTER_SUCCESS:
      return JSON.parse(JSON.stringify(
        Object.assign({}
          , state
          , { filters: action.payload, error: false })
      ));

    case user.CREATE_FILTER_FAILURE:
      return Object.assign({}, state, { filters: action.payload, error: true }
      );

    case user.DELETE_FILTER:
      let filters = state.filters.filter(f => f.id !== action.payload.filter.id);
      return Object.assign({}, state, { filters: filters, error: false })

    case user.SAVE_FLEX_FAILURE:
      return Object.assign({}, state, { error: true });

    case user.FETCH_FILTERS:
      return Object.assign({}, state);

    case user.FETCH_FILTERS_SUCCESS:

      action.payload.forEach(filter => {

        const mongoFilter = filter.screens || {};

        Object.keys(mongoFilter).forEach(filterTerm => {
          if (!mongoFilter[filterTerm].includes) return;
          if (mongoFilter[filterTerm].includes('$gte') || mongoFilter[filterTerm].includes('$lte') || mongoFilter[filterTerm].includes('$exists')) {

            if (mongoFilter[filterTerm].includes('"')) {
              mongoFilter[filterTerm] = JSON.parse(mongoFilter[filterTerm]);
            }

          }

        });
        filter.screens = mongoFilter;
      })

      return Object.assign({}, state, { filters: action.payload });

    case user.UPDATE_FILTER:
      const index = state.filters.findIndex(filter => filter.ref === action.payload.filter.ref);

      index !== -1 ? state.filters[index] = action.payload.filter : state.filters.push(action.payload.filter)
      return { ...state };

    case user.UPDATE_FILTER_SUCCESS:
      return state;

    case user.ADD_STOCK_TO_FILTER:
      return Object.assign({}, state);

    case user.REMOVE_STOCK_FROM_FILTER:
      return Object.assign({}, state);

    default:
      return state;
  }
}

export const getUser = (state: State) => state;
export const getFilters = (state: State) => (state['filters'] || []);
export const getScreensFilter = (state: State) => {
  return (state['filters'] ? state['filters'].find(f => f.ref == 'all') : []) || []
};
export const getUpperFilter = (state: State) => {
  return (state['filters'] ? state['filters'].find(f => f.ref == 'upper') : []) || []
};
export const getLowerFilter = (state: State) => {
  return (state['filters'] ? state['filters'].find(f => f.ref == 'lower') : []) || []
};



// WEBPACK FOOTER //
// ./src/reducers/user.reducer.ts